import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const keyValuePairsContainerClasses = generateUtilityClasses('KeyValuePairsContainer', [
  // 고정 클래스 (target으로 적용)
  'root',
]);
